// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I6MP","footer":"styles_footer__jiXPs","passCodeTooltip":"styles_passCodeTooltip__3LCxI"};